// Simple session manager for security
class SessionManager {
    constructor(timeoutMinutes = 30) {
        this.timeoutMs = timeoutMinutes * 60 * 1000;
        this.lastActivity = Date.now();
        this.setupActivityListeners();
    }

    setupActivityListeners() {
        // Track user activity
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
        
        events.forEach(event => {
            document.addEventListener(event, () => {
                this.updateActivity();
            }, true);
        });

        // Check session timeout every minute
        setInterval(() => {
            this.checkSessionTimeout();
        }, 60000);
    }

    updateActivity() {
        this.lastActivity = Date.now();
        this.saveSessionData();
    }

    checkSessionTimeout() {
        const now = Date.now();
        const timeSinceActivity = now - this.lastActivity;

        if (timeSinceActivity > this.timeoutMs) {
            this.logout('Session expired due to inactivity');
        }
    }

    saveSessionData() {
        try {
            const sessionData = {
                lastActivity: this.lastActivity,
                timeoutMs: this.timeoutMs
            };
            localStorage.setItem('sessionData', JSON.stringify(sessionData));
        } catch (error) {
            console.error('Error saving session data:', error);
        }
    }

    loadSessionData() {
        try {
            const sessionData = localStorage.getItem('sessionData');
            if (sessionData) {
                const data = JSON.parse(sessionData);
                this.lastActivity = data.lastActivity || Date.now();
                this.timeoutMs = data.timeoutMs || this.timeoutMs;
            }
        } catch (error) {
            console.error('Error loading session data:', error);
            this.lastActivity = Date.now();
        }
    }

    logout(reason = 'Session ended') {
        console.log('Logging out:', reason);
        
        // Clear all storage
        try {
            localStorage.clear();
            sessionStorage.clear();
        } catch (error) {
            console.error('Error clearing storage:', error);
        }

        // Redirect to login
        window.location.href = '/signin';
    }

    getRemainingTime() {
        const now = Date.now();
        const timeSinceActivity = now - this.lastActivity;
        return Math.max(0, this.timeoutMs - timeSinceActivity);
    }

    getRemainingMinutes() {
        return Math.ceil(this.getRemainingTime() / (1000 * 60));
    }
}

export default SessionManager; 